import { sendEvent } from "scripts/GoogleAnalytics"
import Image from "next/image"
import Hint from "scenes/CarScene/PanoramaOverlay/Hint"
import { useCallback, useContext } from "react"
import { CarContext } from "scenes/CarScene/CarContext"

export default function PanoramaSlide() {
  const { car, page, setShowMedia } = useContext(CarContext)
  const { brand, model, version, imageInterior } = car

  const handleClick = useCallback(
    e => {
      if (e.defaultPrevented) return
      setShowMedia("panorama")
      sendEvent("360º photos", { event_category: page, event_label: "360º photos carrusel" })
    },
    [page, setShowMedia]
  )

  return (
    <>
      <Hint show />
      <Image
        onClick={handleClick}
        height={480}
        width={720}
        alt={`${brand}-${model}-${version}-interior`}
        src={`e_blur:200${imageInterior}`}
      />
    </>
  )
}
